import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { AllFgInspectionsResponse, FgInspectionDto, FgInspectionResponse } from '@gtpl/shared-models/production-management';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getManager, Raw, Repository } from 'typeorm';
import { FgInspectionAdapter } from './dto/fg-inspection.adapter';
import { FgInspectionDTO } from './dto/fg-inspection.dto';
import { FgInspectionRequest } from './dto/fg-inspection.request';
import { FgInspection } from './entities/fg-inspection.entity';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { FgInspectionSamples } from './entities/fg-inspection-samples.entity';
import { FgInspectionRepository } from './repositories/fg-inspection.repository';
import appSettings from 'apps/services/config';
const fgInspectionTable = appSettings.production_db + '.fgInspection'
const salesSoTable = appSettings.sales_db + '.sale_order';
const salesSoItemTable=appSettings.sales_db + '.sale_order_items'




@Injectable()
export class FgInspectionService {

    constructor(
        private fgInspectionRepo: FgInspectionRepository,
        private fgInspectionAdapter: FgInspectionAdapter,

    ) { }


    /**
     * 
     * @param testDto 
     * @param isUpdate 
     * @returns created Data
     */
    async getFgInspectionDetailsWithoutRelations(saleOrderId: number,saleOrderItemId:number): Promise<FgInspection> {
        // tslint:disable-next-line: typedef
        const fgInspectionResponse = await this.fgInspectionRepo.findOne({
            where: { saleOrderId: saleOrderId,saleOrderItemId:saleOrderItemId },
        });
        if (fgInspectionResponse) {
            return fgInspectionResponse;
        } else {
            return null;
        }
    }

    async createFgInspection(fgInspectionDto: FgInspectionDTO, isUpdate: boolean): Promise<FgInspectionResponse> {

        try {
            if (!isUpdate) {
                const fgInspectionEntity = await this.getFgInspectionDetailsWithoutRelations(fgInspectionDto.saleOrderId,fgInspectionDto.saleOrderItemId);
                if (fgInspectionEntity) {
                    //return new InformationMessageError(11104, "State already exists");
                    throw new ErrorResponse(11104, 'FgInspection already exists');
                }
            }
            else {
                const fgInspectionEntity = await this.getFgInspectionDetailsWithoutRelations(fgInspectionDto.saleOrderId,fgInspectionDto.saleOrderItemId);
                if (fgInspectionEntity) {
                    if (fgInspectionEntity.fgInspectionId != fgInspectionDto.fgInspectionId) {
                        throw new ErrorResponse(11104, 'FgInspection already exists');
                    }
                }
            }
            const convertedEntity: FgInspection = this.fgInspectionAdapter.convertDtoToEntity(fgInspectionDto);
            const savedEntity: FgInspection = await this.fgInspectionRepo.save(
                convertedEntity
            );

            if (savedEntity) {
                // generating resposnse
                const response = new FgInspectionResponse(true, 1, isUpdate ? 'FgInspection Updated Successfully' : 'FgInspection Created Successfully');
                return response;

            } else {
                //return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
                throw new ErrorResponse(11106, 'FgInspection saved but issue while transforming into DTO');
            }
        } catch (error) {
            // when error occures while saving the data , the execution will come to catch block.
            // tslint:disable-next-line: typedef
            return error;
        }
    }

    async getAllFgInspections(): Promise<AllFgInspectionsResponse> {
        try {
            const manager = getManager()
            const query = `SELECT s.sale_order_id as saleOrderId,s.sale_order_item_id as saleOrderItemId,s.inspection_date as date,s.fgInspection_id as fgInspectionId,s.section as section,s.lot_number as lotNumber,so.sale_order_no as soNumber,  concat(b.brand_name, "/", p.name, "/", soi.min_grade_id,'-',soi.max_grade_id) as item FROM ` + fgInspectionTable + ` s 
            LEFT JOIN ` + salesSoItemTable + ` soi ON soi.sale_order_item_id=s.sale_order_item_id 
            LEFT JOIN ` + salesSoTable + ` so ON so.sale_order_id=s.sale_order_id
            LEFT JOIN ` + appSettings.masters_db + `.brands b ON b.brand_id=soi.brand_id
            LEFT JOIN `+ appSettings.masters_db + `.products p ON p.product_id=soi.item_id
            LEFT JOIN `+ appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id=soi.varient_id
            ORDER BY  fgInspection_id ASC` 
            const qEntities: FgInspectionDTO[] = await manager.query(query)
            if (qEntities) {

                const response = new AllFgInspectionsResponse(true, 1, 'FgInspection retrieved successfully', qEntities);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data Not Found');
            }
        } catch (err) {
            console.log(err)
            return err;
        }
    }
    async getAllActiveFgInspections(): Promise<AllFgInspectionsResponse> {
        // const page: number = 1;
        try {
            const query = 'SLECT '
            const qDtos: FgInspectionDTO[] = [];
            //retrieves all companies
            const qEntities: FgInspection[] = await this.fgInspectionRepo.find({
                order: { fgInspectionId: 'ASC' },
            });
            console.log(qEntities)
            if (qEntities) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                qEntities.forEach(Entity => {
                    const convertedDto: FgInspectionDTO = this.fgInspectionAdapter.convertEntityToDto(
                        Entity
                    );
                    qDtos.push(convertedDto);
                });
                const response = new AllFgInspectionsResponse(true, 11108, "FgInspection retrieved successfully", qDtos);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data not found');
            }
        } catch (err) {
            return err;
        }
    }

    async activateOrDeactivateFgInspection(qReq: FgInspectionRequest): Promise<FgInspectionResponse> {
        try {
            const qExists = await this.getFgInspectionById(qReq.fgInspectionId);
            if (qExists) {
                if (qReq.versionFlag !== qExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current FgInspection information.Refresh and try again');
                } else {

                    const qStatus = await this.fgInspectionRepo.update(
                        { fgInspectionId: qReq.fgInspectionId },
                        { isActive: qReq.isActive, updatedUser: qReq.updatedUser });

                    if (qExists.isActive) {
                        if (qStatus.affected) {
                            const fgInspectionResponse: FgInspectionResponse = new FgInspectionResponse(true, 10115, 'FgInspection is de-activated successfully');
                            return fgInspectionResponse;
                        } else {
                            throw new ErrorResponse(10111, 'FgInspection is already deactivated');
                        }
                    } else {
                        if (qStatus.affected) {
                            const fgInspectionResponse: FgInspectionResponse = new FgInspectionResponse(true, 10114, 'FgInspection is activated successfully');
                            return fgInspectionResponse;
                        } else {
                            throw new ErrorResponse(10112, 'FgInspection is already  activated');
                        }
                    }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getFgInspectionById(fgInspectionId: number): Promise<FgInspection> {
        const response = await this.fgInspectionRepo.findOne({
            where: { fgInspectionId: fgInspectionId },
        });
        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async createFgInspectionInfo(FgInspectionInfo: FgInspectionDTO): Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        try {
            if (!FgInspectionInfo.fgInspectionId){
            const fgInspectionEntity = await this.getFgInspectionDetailsWithoutRelations(FgInspectionInfo.saleOrderId,FgInspectionInfo.saleOrderItemId);
            if (fgInspectionEntity) {
                //return new InformationMessageError(11104, "State already exists");
                throw new ErrorResponse(11104, 'FgInspection already exists');
            }
        }
           const convertedDtoRmE = await this.fgInspectionAdapter.convertDtoToEntity(FgInspectionInfo);
            await manager.startTransaction();
            const savedInfoRmE = await manager.getCustomRepository(FgInspectionRepository).save(convertedDtoRmE);

            if (savedInfoRmE) {
                manager.completeTransaction();
                return new CommonResponse(true, 1111, 'FgInspection along with Samples Info are created successfully');
            } else {
                throw new ErrorResponse(9999, 'Creation of FgInspection failed');
            }
        }
         catch (error) {
            manager.releaseTransaction();
            return error;
        }
    }

    async getAllFgInspectionSamplesForLabelId(qReq: FgInspectionRequest): Promise<FgInspectionResponse> {
        try {
            const qDtos: FgInspectionDTO[] = [];
            const qEntities: FgInspection = await this.fgInspectionRepo.findOne({ where: { fgInspectionId: qReq.fgInspectionId }, relations: ['samplesInfo'] });
           console.log("test",qReq.fgInspectionId)
            if (qEntities) {
                const convertedDto: FgInspectionDTO = this.fgInspectionAdapter.convertEntityToLabelDto(
                    qEntities
                );
                const response = new FgInspectionResponse(true, 1, 'FgInspection retrieved successfully', convertedDto);
                return response;
            } else {
                
                throw new ErrorResponse(99998, 'Data Not Found');
            }
        } catch (err) {
            return err;
        }
    }
}
